import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MingleService } from '@totvs/mingle';
import { LoginService } from './login.service';
import { environment } from 'src/environments/environments';
import { environmentProtheus } from 'src/environments/environment.protheus';
import {
  PgcCustomButtonLocation,
  PgcCustomButtonTiming,
  PgcCustomButtonsResponse,
  PgcCustomButtonActionPayload,
  PgcCustomButtonActionResponse
} from '../models/pgc-custom-buttons.model';

/**
 * Serviço responsável por consultar os botões customizados (Ponto de Entrada)
 * disponíveis para cada localização/timing e executar suas ações no backend.
 */
@Injectable({ providedIn: 'root' })
export class PgcCustomButtonsService {

  private readonly basePath = '/pgcCustomButtons';

  constructor(
    private http: HttpClient,
    private mingleService: MingleService,
    private loginService: LoginService
  ) {}

  /**
   * Retorna a lista de botões customizados configurados para uma determinada localização e timing.
   * @param location Local predefinido (purchaseRequests | quotations)
   * @param timing Momento de execução (before | after)
   */
  getButtons(location: PgcCustomButtonLocation, timing: PgcCustomButtonTiming): Observable<PgcCustomButtonsResponse> {
    const endpoint = `${this.basePath}/buttons?location=${location}&timing=${timing}`;

    if (!this.loginService.isProtheusLogged()) {
      return this.mingleService.gateway.get(`${environment.url}${endpoint}`) as Observable<PgcCustomButtonsResponse>;
    } else {
      return this.http.get<PgcCustomButtonsResponse>(`${environmentProtheus.url}${endpoint}`);
    }
  }

  /**
   * Executa a ação associada a um botão customizado no backend.
   * O backend receberá o identificador da ação, a localização, o timing e o contexto atual,
   * executará o ponto de entrada e retornará uma mensagem de sucesso ou erro.
   * No modo before, a resposta pode incluir filtros customizados para aplicar na listagem.
   * @param payload Dados da execução (action, location, timing, context)
   */
  executeAction(payload: PgcCustomButtonActionPayload): Observable<PgcCustomButtonActionResponse> {
    const endpoint = `${this.basePath}/execute`;

    if (!this.loginService.isProtheusLogged()) {
      return this.mingleService.gateway.post(`${environment.url}${endpoint}`, { body: payload }) as Observable<PgcCustomButtonActionResponse>;
    } else {
      return this.http.post<PgcCustomButtonActionResponse>(`${environmentProtheus.url}${endpoint}`, payload);
    }
  }
}
